


































import Vue, { PropType } from 'vue';
import type { DrawerConfig } from './types';

export default Vue.extend({
  name: 'SearchBannerFormItem',
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    drawerConfig: {
      type: Object as PropType<DrawerConfig>,
      required: true,
    },
    displayValue: {
      type: String,
    },
    active: {
      type: Boolean,
      default: false,
    },
    isDesktop: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    dropdownId(): string {
      return `${this.id}-dropdown`;
    },
  },
  watch: {
    active(isActive: boolean) {
      if (!this.isDesktop) {
        if (isActive) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
    // Ensure body scroll is restored if component is destroyed while active
    document.body.style.overflow = '';
  },
  methods: {
    handleClick() {
      this.$emit('update:active', !this.active);
    },
    handleCloseClick() {
      this.$emit('close', this.id);
      this.$emit('update:active', false);
    },
    handleOverlayClick() {
      this.$emit('update:active', false);
    },
    handleClickOutside(event: MouseEvent) {
      if (this.active && !this.$el.contains(event.target as Node)) {
        this.$emit('update:active', false);
      }
    },
  },
});
